/**
 * 插件对话框壳层：用 shadcn `Dialog` 包裹 `PluginIframe`，用于工具栏 modal 类型与 `openPanel` 的 modal 展示；
 * 关闭时由 `onOpenChange` 交还给调用方清理 store 状态。
 */
import { useEffect, useState } from "react";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/shared/ui/dialog";

import { PluginIframe } from "./plugin-iframe";

interface PluginModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  pluginId: string;
  src: string;
  title: string;
  /** 内容区最大宽度（像素），默认 600 */
  width?: number;
  /** 对话框整体高度（像素）；iframe 区域会扣除标题栏近似高度 */
  height?: number;
}

export function PluginModal({
  open,
  onOpenChange,
  pluginId,
  src,
  title,
  width = 600,
  height = 450,
}: PluginModalProps) {
  const [shouldRenderIframe, setShouldRenderIframe] = useState(open);

  useEffect(() => {
    if (open) {
      setShouldRenderIframe(true);
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        forceMount
        className="flex h-full max-h-[calc(100vh-2rem)] flex-col overflow-hidden p-0"
        style={{ maxWidth: width, height }}
      >
        <DialogHeader className="px-4 pt-4 pb-2">
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="min-h-0 flex-1 overflow-hidden bg-background px-0">
          {shouldRenderIframe && (
            <PluginIframe
              pluginId={pluginId}
              src={src}
              className={open ? "block" : "hidden"}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
